// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3jBvt","video-wrapper":"_2k4Me","title-wrapper":"_1qbxg","subsection-title":"_54_lh","border-bottom":"_3llWz","iframe":"qFU1u"};